import { ShipOrder } from '../ShipOrder';

import { Shipment } from './Shipment';

export class ShipmentTransportSegment {
  id: number;
  shipOrder: ShipOrder;
  shipment: Shipment;
  pickupStopId: number;
  dropOffStopId: number;
  sequence: number;

  constructor(opts: ShipmentTransportSegment) {
    this.id = opts.id;
    this.shipOrder = new ShipOrder(opts.shipOrder);
    this.shipment = new Shipment(opts.shipment);
    this.pickupStopId = opts.pickupStopId;
    this.dropOffStopId = opts.dropOffStopId;
    this.sequence = opts.sequence;
  }
}
